/* eslint-disable max-classes-per-file */

import { toast } from "sonner";

export type ErrorData = {
  code: string;
  message: string;
  details: unknown;
};

export class APIError extends Error {
  constructor(
    public status: number,
    public message: string,
    public data: ErrorData
  ) {
    super(message);
  }
}

export class LinkExpiredError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "LinkExpiredError";
  }
}

export function handleError(
  error: unknown,
  title: string,
  options?: { description?: string }
) {
  if (error instanceof APIError) {
    let description = options?.description || error.message;

    description =
      description && typeof description === "object"
        ? JSON.stringify(description)
        : description;

    toast.error(title, {
      description,
    });
  } else if (error instanceof Error) {
    toast.error(title, {
      description: options?.description || error.message,
    });
  } else {
    toast.error(title, {
      description: options?.description,
    });
  }
}

export function setWithExpiry(key: string, value: unknown, ttl: number) {
  const item = {
    value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key: string) {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export function isChunkFailedError(error: Error) {
  const chunkFailedMessage = /dynamically imported module/;
  return error?.message && chunkFailedMessage.test(error.message);
}
